import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Sayfa adresi (pathname) her değiştiğinde çalışır
        window.scrollTo(0, 0);
    }, [pathname]);

    return null; // Görünür bir şey basmaz, sadece işlevseldir
};

export default ScrollToTop;